var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTokenPocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2449_97128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.1159 0H-0.449219V36H37.1159V0Z",
    fill: "#2980FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8014 15.421H14.806C14.8014 15.3934 14.8014 15.3611 14.8014 15.3335V15.421Z",
    fill: "#29AEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9704 16.2961H18.8954V25.4559C18.8954 25.8887 19.2454 26.2388 19.6783 26.2388H23.1875C23.6204 26.2388 23.9704 25.8887 23.9704 25.4559V16.2961Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4456 9.73828H16.2752H7.18914C6.75623 9.73828 6.40625 10.0883 6.40625 10.5212V13.6987C6.40625 14.1317 6.75623 14.4816 7.18914 14.4816H9.32134H10.1687V15.4211V25.4788C10.1687 25.9117 10.5187 26.2617 10.9516 26.2617H14.2857C14.7186 26.2617 15.0686 25.9117 15.0686 25.4788V15.4211V15.3336V14.4816H15.916H16.2614H16.4318C17.7396 14.4816 18.8034 13.4178 18.8034 12.11C18.8172 10.8021 17.7535 9.73828 16.4456 9.73828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.975 16.2961V22.6881C24.15 22.7296 24.3296 22.7618 24.5138 22.7895C24.7717 22.8263 25.0388 22.8493 25.3059 22.8539C25.3198 22.8539 25.3336 22.8539 25.352 22.8539V17.7698C24.5829 17.7191 23.975 17.079 23.975 16.2961Z",
    fill: "url(#paint0_linear_2449_97128)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4532 9.73828C21.8336 9.73828 18.8954 12.6764 18.8954 16.2961C18.8954 19.4092 21.0645 22.0157 23.975 22.6881V16.2961C23.975 15.4809 24.6381 14.8178 25.4532 14.8178C26.2683 14.8178 26.9315 15.4809 26.9315 16.2961C26.9315 16.9823 26.4664 17.5579 25.8309 17.7237C25.7111 17.7559 25.5822 17.7743 25.4532 17.7743V22.8539C25.5822 22.8539 25.7065 22.8493 25.8309 22.8447C29.2755 22.6466 32.011 19.7914 32.011 16.2961C32.0156 12.6764 29.0775 9.73828 25.4532 9.73828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4532 22.8539V17.7744C25.4164 17.7744 25.3841 17.7744 25.3473 17.7698V22.8539C25.3841 22.8539 25.421 22.8539 25.4532 22.8539Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2449_97128",
    x1: 25.4554,
    y1: 19.576,
    x2: 23.9757,
    y2: 19.576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9667,
    stopColor: "white",
    stopOpacity: 0.3233
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2449_97128"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenPocket);
export default __webpack_public_path__ + "static/media/token_pocket.b43ec948680e098a747353afd65c3606.svg";
export { ForwardRef as ReactComponent };